export async function guestFetch(query, options = {}) {
  const response = await fetch(`/api/billing?service=guest&${query}`, options);
  const result = await response.json();
  if (!response.ok) throw new Error(result.error || 'Operazione non riuscita.');
  return result;
}
